import { call, put, takeEvery } from 'redux-saga/effects';
import { LOCALSESSIONDATAKEYS, SUCCESS, USER_ACTIVITY_LOGS, _BROTHERPLUS_CSAGENT_API_ENDPOINTS, _BROTHER_PLUS_API_ENDPOINTS } from '../../../constants/AppConstants';
import { _CALLPUTAPI } from '../../../api/apiHandler';
import { fetchCancelServiceFailure, fetchCancelServiceRequest, fetchCancelServiceSuccess } from './cancelServiceSlice';
import i18next from 'i18next';
import CancelOrderPayload from '../../../utils/MyAccount/CancelOrderPayload';
import { getLocalSessionData } from '../../../utils/Authentication/handleUserSession';
import { userRoles } from '../../../constants/UserRoles';
import UserActivityLogsPayload from '../../../utils/AdminPortal/UserActivityLogsPayload';


async function _CANCELSERVICE(payload, role) {
  if (role && role === userRoles.CSAGENT_ADMIN) {
    const endpoint = _BROTHERPLUS_CSAGENT_API_ENDPOINTS.CANCEL_USER_SUBSCRIPTION;
    const logDetails = {
      action: USER_ACTIVITY_LOGS.BROTHERPLUS_CANCEL_SUBSCRIPTION,
      description: `Cancelled subscription for the user ${payload.UserId} for the device ${payload.DeviceId}`
    }
    const payloadInfo = {
      "userId": payload.UserId,
      "deviceId": payload.DeviceId,
      "sapBpId": payload.SapBpId,
      "personalOrBusiness": payload.PersonalOrBusiness,
      "displayName": payload.DisplayName,
      "model": payload.Model,
      "serialNumber": payload.serialNumber,
      "cancelSubscriptionReasonCodes": payload.ReasonCodes,
      "cancelSubscriptionReasonText": payload.ReasonText,
      servicePortalUser: await UserActivityLogsPayload(logDetails)
    }
    return _CALLPUTAPI(endpoint, payloadInfo)
      .then(response => {
        return response;
      })
      .catch((error) => {
        throw error;
      });
  } else {
    const endpoint = _BROTHER_PLUS_API_ENDPOINTS.CANCEL_SERVICE;
    return _CALLPUTAPI(endpoint, payload)
      .then(response => {
        return response;
      })
      .catch((error) => {
        throw error;
      });
  }
}

function* fetchCancelServiceSaga(action) {
  try {
    const uid = action?.payload?.uid
    const deviceId = action?.payload?.deviceId
    const displayName = action?.payload?.displayName
    const feedbackSelection = action?.payload?.reasonCodes
    const otherReason = action?.payload?.otherReason
    const customerCountryCode = action?.payload?.countryCode
    const role = action?.payload?.role
    const personalOrBusiness = action?.payload?.personalOrBusinessAccount
    const serialNumber = (role && role === userRoles.CSAGENT_ADMIN)
      ? action?.payload?.serialNumber
      : getLocalSessionData(LOCALSESSIONDATAKEYS.SERIAL_NUMBER)
    const Model = (role && role === userRoles.CSAGENT_ADMIN)
      ? action?.payload?.model
      : getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_MODEL)
    const BPID = (role && role === userRoles.CSAGENT_ADMIN)
      ? action?.payload?.BPID
      : null

    const cancelOrderPayload = CancelOrderPayload({
      'reasonSelection': feedbackSelection,
      'otherReason': otherReason,
      'deviceID': deviceId,
      'customerCountryCode': customerCountryCode,
      'uid': uid,
      'displayName': displayName,
      'serialNumber': serialNumber,
      'Model': Model,
      'BPID': BPID,
      'personalOrBusiness': personalOrBusiness
    });
    const cancelService = yield call(_CANCELSERVICE, cancelOrderPayload, role);
    if (cancelService.actionStatus.toUpperCase() === SUCCESS) {
      yield put(fetchCancelServiceSuccess(cancelService));
    }
    else {
      yield put(fetchCancelServiceFailure({ message: i18next.t("ERROR_CONTENT.ERR_INFO.TECHNICAL_ERROR") }));
    }
  } catch (error) {
    yield put(fetchCancelServiceFailure({ message: error.message }));
  }
}

export default function* watchFetchCancelService() {
  yield takeEvery(fetchCancelServiceRequest.type, fetchCancelServiceSaga);
}
